<template>
  <div class="wallet-container">
    <div class="remain-money-container">
      <img src="../../../assets/remain-money.svg" alt="" />
      <div class="remain-tip">账户余额（人民币）：</div>
      <div class="remain-money">{{balance}}</div>
      <div class="withdrawal-btn" @click="toShowWithdrawalDialog">提现</div>
    </div>
    <div class="wallet-list">
      <div class="wallet-item total">
        <div class="wallet-title">
          <div>累计收益</div>
          <img src="../../../assets/total.svg" alt="" />
        </div>
        <div class="wallet-money">￥{{ statRebate }}</div>
      </div>
      <div class="wallet-item today">
        <div class="wallet-title">
          <div>今日结算</div>
          <img src="../../../assets/today.svg" alt="" />
        </div>
        <div class="wallet-money">￥{{ todayRebate }}</div>
      </div>
      <div class="wallet-item yesterday">
        <div class="wallet-title">
          <div>昨日结算</div>
          <img src="../../../assets/yesterday.svg" alt="" />
        </div>
        <div class="wallet-money">￥{{ yesterdayRebate }}</div>
      </div>
      <div class="wallet-item road">
        <div class="wallet-title">
          <div>在路上</div>
          <img src="../../../assets/road.svg" alt="" />
        </div>
        <div class="wallet-money">￥{{ noSettledRebate }}</div>
      </div>
    </div>

    <WithdrawalDialog v-if="isShowDialog" @closeDialog="closeWithdrawalDialog"></WithdrawalDialog>
  </div>
</template>

<script>
import { getUserInfo } from "@/api/home";
import WithdrawalDialog from "./withdrawalDialog"
export default {
    components:{ WithdrawalDialog },
  data() {
    return {
      todayRebate: 0,
      yesterdayRebate: 0,
      statRebate: 0,
      noSettledRebate: 0,
      balance:0,
      isShowDialog:false
    };
  },
  created() {
    this.getUserInfo();
  },
  methods: {
    closeWithdrawalDialog(data) {
        this.isShowDialog = false
        if(data == true) {
            this.getUserInfo()
        }
    },
    toShowWithdrawalDialog() {
        this.isShowDialog = true
    },
    async getUserInfo() {
      const { data } = await getUserInfo();
      console.log(data, "data");
      this.balance = data.balance;
      this.statRebate = data.stat_rebate;
      this.todayRebate = data.stat_today_rebate;
      this.yesterdayRebate = data.stat_yesterday_rebate;
      this.noSettledRebate = data.stat_rebate_no_settled;

      stat_yesterday_rebate: "0.00";
    },
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";

.wallet-container {
  width: 100%;
  margin-left: 17px;
}
.remain-money-container {
  margin-right: 40px;
  margin-left: 30px;
  height: 245px;
  background: linear-gradient(135deg, #6bc9ff 0%, #3998fe 100%);
  border-radius: 20px;
  border: 2px solid #5cbbfe;
}
.remain-money-container img {
  margin: 24px 0 12px 24px;
}
.remain-tip {
  font-size: 15px;
  font-weight: 400;
  color: #ffffff;
  margin-left: 25px;
}
.remain-money {
  height: 56px;
  font-size: 40px;
  font-weight: 600;
  color: #ffffff;
  margin-left: 24px;
  padding: 8px 0;
  box-sizing: border-box;
}
.withdrawal-btn {
  width: 168px;
  height: 52px;
  background: #ffffff;
  border-radius: 31px;
  border: 3px solid #ffffff;
  float: right;
  margin-right: 35px;
  font-size: 20px;
  font-weight: 600;
  color: @primary;
  line-height: 52px;
  text-align: center;
  cursor: pointer;
}
.wallet-list {
  margin-top: 40px;
  margin-right: 40px;
  margin-left: 30px;
  display: flex;
  justify-content: space-between;
}
.wallet-item {
  width: 214px;
  height: 106px;
  &.total {
    background: url("../../../assets/total-bg.svg");
  }
  &.today {
    background: url("../../../assets/today-bg.svg");
  }
  &.yesterday {
    background: url("../../../assets/yesterday-bg.svg");
  }
  &.road {
    background: url("../../../assets/road-bg.svg");
  }
}

.wallet-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 11px;
  padding: 20px 16px 0;
  box-sizing: border-box;
  font-size: 16px;
  font-weight: 600;
  color: #ffffff;
}
.wallet-money {
  font-size: 24px;
  font-weight: 600;
  color: #ffffff;
  margin-left: 17px;
}
</style>